import {
  addCommasToNumbersAndRound,
  toTwoDecimalPlaces,
} from '../../../../../../utilities/numberFormatters';
import { CustomColumn } from '../../../../../../types/components/tables/tableTypes';
import { VarBacktestApiResponse } from '../../queries';

export interface IExceedanceTableData {
  t: string;
  tplusone: string;
  pxt: string;
  ptplusone: string;
  return: string;
  nav: string | number;
  pdivl: string;
  vart: string;
  ratio: string;
}
export const csvExceedanceTable = [
  't',
  'tplusone',
  'pxt',
  'ptplusone',
  'return',
  'nav',
  'pdivl',
  'vart',
  'ratio',
];

export const exceedanceColumns: CustomColumn<IExceedanceTableData>[] = [
  {
    title: 'T',
    field: 't',
    cellStyle: {
      textAlign: 'center',
    },
    headerStyle: {
      textAlign: 'center',
    },
  },
  {
    title: 'T+1',
    field: 'tplusone',

    cellStyle: {
      textAlign: 'center',
    },
    headerStyle: {
      textAlign: 'center',
    },
  },
  {
    title: 'Px(T)',
    field: 'pxt',
    render: (rowData: IExceedanceTableData) => toTwoDecimalPlaces(rowData.pxt),
    headerStyle: { textAlign: 'center' },
    cellStyle: { textAlign: 'center' },
  },
  { title: 'P(T+1)', field: 'ptplusone' },
  { title: 'Return(T+1)', field: 'return' },
  { title: 'NAV(T)', field: 'nav' },
  { title: 'P/L(T+1)', field: 'pdivl' },
  { title: 'VaR(T)', field: 'vart' },
  { title: 'P/L-VaR Ratio', field: 'ratio' },
];

export function buildExceedanceData(
  inputData: VarBacktestApiResponse[],
): IExceedanceTableData[] {
  if (!inputData || !inputData.length) return [];

  const { exceedance_data } = inputData[0];
  exceedance_data.shift();
  const returnedData: IExceedanceTableData[] = exceedance_data
    .map((instance: (string | number)[], index: number) => {
      return {
        t: String(instance[0]),
        tplusone: String(instance[1]),
        pxt: String(instance[2]),
        ptplusone: String(instance[3]),
        return: String(instance[4]),
        nav: addCommasToNumbersAndRound(instance[5]),
        pdivl: addCommasToNumbersAndRound(instance[6]),
        vart: addCommasToNumbersAndRound(instance[7]),
        ratio: String(instance[8]),
      };
    })
    .filter((el) => el !== undefined);

  return returnedData;
}
